import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { PAGES, RECEPISSES } from "@/lib/content";
import { PageHero, SectionTitle, IconCards } from "@/components/kit";

const NEXT = {
  "ong-presentation": ["/ong/activites-sante", "Nos activités de santé"],
  "ong-health": ["/ong/campagnes", "Nos campagnes"],
  "ong-principles": ["/ong/partenaires-etrangers", "Devenir partenaire"],
  "asso-presentation": ["/association/formation", "Centre de formation"],
  "asso-agri": ["/association/formation", "Centre de formation"],
};

export default function InfoPage({ pageKey }) {
  const p = PAGES[pageKey];
  useSeo(`${p.title} — ${p.eyebrow}`, p.seo);
  const [nextTo, nextLabel] = NEXT[pageKey];
  return (
    <div data-testid={`info-page-${pageKey}`}>
      <PageHero eyebrow={p.eyebrow} title={p.title} intro={p.intro} image={p.image} />
      {p.sections.map((s) => (
        <section key={s.title} className="pagne py-16">
          <div className="container-x">
            <SectionTitle title={s.title} className="mb-10" />
            <IconCards items={s.items} testid={`${pageKey}-cards`} />
          </div>
        </section>
      ))}
      <section className="container-x flex flex-col gap-6 py-14 md:flex-row md:items-center md:justify-between">
        <p className="max-w-xl text-sm text-neutral-600">{RECEPISSES[p.universe]}</p>
        <Link to={nextTo} className="btn-u" data-testid="info-page-next">{nextLabel} <ArrowRight className="h-4 w-4" /></Link>
      </section>
    </div>
  );
}
